import _ from 'lodash';
function setDiff(item, diff = {}) {
    item = _.cloneDeep(item);
    for (const key in diff)
        _.set(item, key, diff[key]);
    return item;
}
export default setDiff;
//# sourceMappingURL=setDiff.js.map